import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { DocumentoRoutingModule,ROUTABLE_COMPONENTS} from './documento.routing';
import { MatButtonModule,   MatDatepickerModule, MatInputModule, MatCheckboxModule, MatSlideToggleModule, MatTableModule, MatFormFieldModule,MatPaginatorModule } from '@angular/material';
import { FabButtonGroupModule } from '../../../shared/fabbuttongroup/fabbuttongroup.module';
import { SectionBarModule } from '../../../shared/sectionbar/sectionbar.module';

//ccontrols
import { TitlebarModule } from '../../../shared/titlebar/titlebar.module';
import { HeaderModule } from '../../../shared/header/header.module';
import { LoaderModule } from '../../../shared/loader/loader.module';
import { SnackbarModule } from '../../../shared/snackbar/snackbar.module';
import { DocumentoEditComponent } from './edit/documento-edit.component';
import { DocumentoComponent } from './documento.component';
import { DocumentoService } from './shared/documento.service';
import { DocumentoListComponent } from './list/documento-list.component';
import { DocumentoViewComponent } from './view/documento-view.component';
import { DocumentoNewComponent } from './new/documento-new.component';
import { FileuploadModule } from 'src/app/shared/fileupload/fileupload.module';
import { GridEmptyModule } from 'src/app/shared/gridempty/gridempty.module';




@NgModule({
    imports: [
      BrowserModule,
      MatTableModule,
      MatDatepickerModule,
      DocumentoRoutingModule,GridEmptyModule,
      MatCheckboxModule, MatButtonModule, MatInputModule, MatPaginatorModule,
      FormsModule, ReactiveFormsModule,
      FabButtonGroupModule,FileuploadModule,
      SectionBarModule, MatSlideToggleModule,
      TitlebarModule, HeaderModule, LoaderModule, SnackbarModule, MatFormFieldModule
    ],
    entryComponents: [],
    exports: [
      DocumentoViewComponent,
      DocumentoListComponent,
      DocumentoEditComponent,
      DocumentoNewComponent
    ],
    declarations: [

        DocumentoViewComponent,
        DocumentoListComponent,
        DocumentoEditComponent,
        DocumentoNewComponent,
        DocumentoComponent,
        ROUTABLE_COMPONENTS
    ],
    providers: [DocumentoService],
    bootstrap: []
})
export class DocumentoModule {
}
